<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
<div class="ci-assign__backdrop" (click)="cancel()">
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <div
    class="ci-assign"
    role="dialog"
    aria-modal="true"
    data-testid="ci-mapping-assign-dialog"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [attr.aria-labelledby]="ids.title"
    (click)="$event.stopPropagation()"
  >
    <div class="ci-assign__header">
      <h2 class="ci-assign__title" [id]="ids.title">{{ 'ciMapping.dialog.title' | translate }}</h2>
      <div class="ci-assign__subtitle">{{ subtitle() }}</div>
    </div>

    <div class="ci-assign__body">
      <label class="ci-assign__label" [for]="ids.search">{{ 'ciMapping.dialog.pickLabel' | translate }}</label>
      <input
        #search
        class="ci-assign__search"
        type="search"
        role="combobox"
        autocomplete="off"
        aria-autocomplete="list"
        cdkFocusInitial
        [attr.aria-expanded]="cases().length > 0"
        [id]="ids.search"
        [attr.aria-controls]="ids.list"
        [attr.aria-activedescendant]="activeId()"
        [attr.maxlength]="fieldLengths.NAME_MAX"
        [placeholder]="'ciMapping.dialog.searchPlaceholder' | translate"
        (input)="onSearch(search.value)"
        (keydown)="onKeydown($event)"
      />

      <ul
        #list
        class="ci-assign__list"
        role="listbox"
        [id]="ids.list"
        [attr.aria-label]="'ciMapping.dialog.listAria' | translate"
        [attr.aria-busy]="loading()"
      >
        @for (testCase of cases(); track testCase.id; let i = $index) {
          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
          <li
            class="ci-assign__option"
            role="option"
            [id]="ids.option + i"
            [class.ci-assign__option--active]="activeIndex() === i"
            [attr.aria-selected]="activeIndex() === i"
            [attr.aria-disabled]="busy()"
            (click)="pick(testCase)"
          >
            <code class="ci-assign__key">{{ testCase.key }}</code>
            <span class="ci-assign__option-title">{{ testCase.title }}</span>
            <mat-icon class="ci-assign__chevron" aria-hidden="true">chevron_right</mat-icon>
          </li>
        }
      </ul>

      <div class="ci-assign__status" role="status">
        @if (loading()) {
          <span data-testid="ci-assign-loading">{{ 'ciMapping.dialog.loading' | translate }}</span>
        } @else if (loadError()) {
          <span data-testid="ci-assign-load-error">{{ 'ciMapping.dialog.loadError' | translate }}</span>
        } @else if (cases().length === 0) {
          <span data-testid="ci-assign-empty">{{ 'ciMapping.dialog.empty' | translate }}</span>
        }
      </div>

      @if (errorKey(); as errorKey) {
        <p class="ci-assign__error" role="alert">{{ errorKey | translate }}</p>
      }
    </div>
  </div>
</div>
